import BigNumber from 'bignumber.js';

BigNumber.config({ DECIMAL_PLACES: 15 });

export const toCents = (amount: number | string): number => safeNumber(amount).times(100).toNumber();
export const fromCents = (amountInCents: number | string): number =>
  parseFloat(safeNumber(amountInCents).dividedBy(100).toFixed(2));

export const safeNumber = (number: string | number): BigNumber => new BigNumber(number);
